export const pages = {
    home: '首页',
    modelBase: '模型库',
    houseTypeLibrary: '户型库',
    about: '关于',
    more: '更多',
    changeBatch: '换一批',
    userCenter: '个人中心',
    accountSetting: '账号设置',
    logout: '退出登录',
    addCollect: '添加收藏',
    add: '添加',
    newFavorites: '输入新建收藏夹',
    select: '选择',
    shortcutCollect: '一键收藏',
    collect: '收藏',
    moveCollect: '移动到收藏夹',
    customerService: '客户服务',
    person: '个人',
    switchAccount: '切换账号',
    corporateAccount: '企业账号',
    solution: '解决方案',
    publicDecoration: '公装 • 商业地产',
};
